<app-master-data-table [data]="this.masterCommonService.partNumberList" [columns]="partnumberColumns" title="Part Number List"
  addButtonLabel="Part Number" (add)="openAddUpdatePartNumberDialog('add')"
  (update)="openAddUpdatePartNumberDialog('update', $event)" (delete)="deletePartNumber($event)">
</app-master-data-table>